/* =========================================================================
   Morning Water Challenge (relaunch) — client behaviour for the mwc-* sections
   - Add to cart for every "Join" CTA (config comes from the MWC Pricing section)
   - Smooth scroll for [data-mwc-scroll-to]
   - Sticky mobile CTA: hidden while the pricing card is on screen / after final CTA
   - Pricing gallery thumbnails
   - Analytics: Shopify Customer Events (Shopify.analytics.publish) + fbq/gtag if present
   Safe to load once per page; re-binds when the theme editor reloads a section.
   ========================================================================= */
(function () {
  if (window.__mwcChallenge) return;
  window.__mwcChallenge = true;

  var doc = document;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Analytics ---------- */
  function track(event, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(event, data);
      }
    } catch (e) {}
    if (window.fbq) {
      if (event === 'mwc_cta_click') window.fbq('trackCustom', 'MWC_CTAClick', data);
      else window.fbq('trackCustom', 'MWC_SectionView', data);
    }
    if (window.gtag) window.gtag('event', event, data);
  }

  /* ---------- Config (from MWC Pricing section) ---------- */
  function getConfig() {
    var el = doc.getElementById('mwc-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function scrollToSel(sel) {
    var target = sel && doc.querySelector(sel);
    if (!target) return false;
    // A display:contents element has no box (the buy box on phones), so
    // scroll to whichever of its children sits highest on screen instead.
    if (getComputedStyle(target).display === 'contents') {
      var best = null, bestTop = Infinity;
      Array.prototype.forEach.call(target.children, function (c) {
        var r = c.getBoundingClientRect();
        if (r.height && r.top < bestTop) { bestTop = r.top; best = c; }
      });
      if (best) target = best;
    }
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    // Lazy images above the target can load mid-scroll and push it down; re-align once.
    var el = target;
    setTimeout(function () {
      var offset = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
      if (Math.abs(el.getBoundingClientRect().top - offset) > 4) el.scrollIntoView({ behavior: 'auto', block: 'start' });
    }, reduceMotion ? 50 : 900);
    return true;
  }

  /* ---------- Add to cart ---------- */
  function showError(anchor, message) {
    var box = anchor.parentNode.querySelector('.mwc-cta-error');
    if (!box) {
      box = doc.createElement('p');
      box.className = 'mwc-cta-error';
      box.setAttribute('role', 'alert');
      anchor.insertAdjacentElement('afterend', box);
    }
    box.textContent = message;
    box.hidden = false;
  }

  // "Stay on page": refresh the Boost cart drawer so it shows the new line, then open it.
  // Falls back to the cart page if Boost isn't on the page.
  function openCartDrawer() {
    var boost = window.Boost && window.Boost.Cart;
    if (!boost || typeof boost.open !== 'function') {
      window.location.href = root + 'cart';
      return;
    }
    var refreshed;
    try {
      refreshed = typeof boost.refresh === 'function' ? boost.refresh() : null;
    } catch (e) {
      refreshed = null;
    }
    Promise.resolve(refreshed).catch(function () {}).then(function () {
      try { boost.open(); } catch (e) { window.location.href = root + 'cart'; }
    });
  }

  function addItems(items, trigger, afterAdd) {
    if (trigger.getAttribute('aria-busy') === 'true') return;
    trigger.setAttribute('aria-busy', 'true');
    var err = trigger.parentNode.querySelector('.mwc-cta-error');
    if (err) err.hidden = true;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
          var sent = items[0];
          var lines = data.items || [data];
          var line = lines.filter(function (l) { return l.variant_id === sent.id || l.id === sent.id; })[0];
          if (sent.selling_plan && line && !line.selling_plan_allocation) {
            throw new Error('This was added as a one-time purchase instead of a subscription. Please remove it from your cart and try again.');
          }
          return data;
        });
      })
      .then(function (data) {
        doc.dispatchEvent(new CustomEvent('mwc:cart:added', { detail: { items: data.items || [data] } }));
        if (afterAdd === 'checkout') window.location.href = root + 'checkout';
        else if (afterAdd === 'event') {
          trigger.removeAttribute('aria-busy');
          openCartDrawer();
        }
        else window.location.href = root + 'cart';
      })
      .catch(function (e) {
        trigger.removeAttribute('aria-busy');
        showError(trigger, e.message);
      });
  }

  function itemsFromForm(form) {
    var id = Number(form.querySelector('[name="id"]').value);
    var qty = Number((form.querySelector('[name="quantity"]') || {}).value) || 1;
    var planEl = form.querySelector('[name="selling_plan"]');
    var item = { id: id, quantity: qty };
    if (planEl && !planEl.disabled && planEl.value) item.selling_plan = Number(planEl.value);
    // Line item properties: any properties[...] field in the form (e.g. properties[Includes])
    var properties = {};
    new FormData(form).forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    });
    if (Object.keys(properties).length) item.properties = properties;
    return [item];
  }

  /* Delegated so it also works for sections the theme editor re-renders.
     Capture phase keeps theme / app cart scripts from rebuilding the request
     without the selling plan. */
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mwc-add]');
    if (!btn) return;
    var cfg = getConfig();
    if (!cfg || !cfg.variantId) return; // no pricing section: normal link to #mwc-pricing-card
    e.preventDefault();
    e.stopImmediatePropagation();
    var item = { id: cfg.variantId, quantity: cfg.quantity || 1 };
    if (cfg.sellingPlanId) item.selling_plan = cfg.sellingPlanId;
    addItems([item], btn, cfg.afterAdd);
  }, true);

  // Listen on window (capture) so this runs before any document-level submit
  // handler a theme or subscription app registered earlier.
  window.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-mwc-form]');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var cfg = getConfig() || {};
    addItems(itemsFromForm(form), form.querySelector('[type="submit"]') || form, cfg.afterAdd);
  }, true);

  /* CTA click tracking + smooth scroll */
  doc.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('[data-mwc-cta]');
    if (cta) track('mwc_cta_click', { cta_name: cta.getAttribute('data-mwc-cta') });

    var scroller = e.target.closest && e.target.closest('[data-mwc-scroll-to]');
    if (scroller && scrollToSel(scroller.getAttribute('data-mwc-scroll-to'))) e.preventDefault();
  });

  /* ---------- Pricing gallery thumbnails ---------- */
  doc.addEventListener('click', function (e) {
    var thumb = e.target.closest && e.target.closest('.wf2-pc__gallery-thumb');
    if (!thumb) return;
    var gallery = thumb.closest('.wf2-pc__gallery');
    var main = gallery && gallery.querySelector('.wf2-pc__gallery-main img');
    var src = thumb.getAttribute('data-full');
    if (main && src) {
      main.src = src;
      main.removeAttribute('srcset');
      main.alt = thumb.getAttribute('data-alt') || '';
    }
    gallery.querySelectorAll('.wf2-pc__gallery-thumb').forEach(function (t) {
      var on = t === thumb;
      t.classList.toggle('wf2-pc__gallery-thumb--active', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  });


  /* ---------- Plan picker (Monthly / Quarterly) ---------- */
  function selectPlan(label) {
    var group = label.closest('.rl-plans');
    var form = label.closest('[data-mwc-buybox]');
    if (!group || !form) return;
    group.querySelectorAll('.rl-plan').forEach(function (p) {
      var on = p === label;
      p.classList.toggle('rl-plan--selected', on);
      var input = p.querySelector('input[type="radio"]');
      if (input) input.checked = on;
      var radio = p.querySelector('.rl-plan__radio');
      if (radio) radio.innerHTML = on ? '<span class="rl-plan__dot"></span>' : '';
    });
    var input = label.querySelector('input[type="radio"]');
    var mainForm = form.querySelector('form[data-mwc-form="main"]');
    if (input && mainForm) {
      mainForm.querySelector('[name="id"]').value = input.getAttribute('data-variant-id');
      var sp = mainForm.querySelector('[name="selling_plan"]');
      sp.value = input.getAttribute('data-selling-plan-id') || '';
      sp.disabled = !sp.value;
      mainForm.querySelector('[name="quantity"]').value = input.getAttribute('data-quantity') || 1;
    }
    var today = form.querySelector('[data-mwc-today-price]');
    if (today && input) today.textContent = input.getAttribute('data-charge');
  }
  doc.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('.rl-plan input[type="radio"]')) selectPlan(e.target.closest('.rl-plan'));
  });

  /* ---------- Community posts carousel ---------- */
  function postsState(wrap) {
    var track = wrap.querySelector('.rl-posts__track');
    var arrows = wrap.querySelectorAll('.rl-posts__arrow');
    if (!track || arrows.length < 2) return;
    var max = track.scrollWidth - track.clientWidth;
    arrows[0].disabled = track.scrollLeft <= 2;
    arrows[1].disabled = track.scrollLeft >= max - 2;
  }
  doc.addEventListener('click', function (e) {
    var arrow = e.target.closest && e.target.closest('.rl-posts__arrow');
    if (!arrow) return;
    var wrap = arrow.closest('.rl-posts');
    var track = wrap.querySelector('.rl-posts__track');
    var item = track.querySelector('.rl-post');
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
    var dir = arrow === wrap.querySelectorAll('.rl-posts__arrow')[0] ? -1 : 1;
    track.scrollBy({ left: dir * step, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
  doc.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('rl-posts__track')) postsState(t.closest('.rl-posts'));
  }, true);
  function initPosts() { doc.querySelectorAll('.rl-posts').forEach(postsState); }

  /* ---------- FAQ (design markup: heading with role="button") ---------- */
  function toggleFaq(q) {
    var item = q.closest('.rl-faq__item');
    var open = !item.classList.contains('rl-faq__item--open');
    item.classList.toggle('rl-faq__item--open', open);
    q.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  doc.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('.rl-faq__item .wf2-faq__q');
    if (q) toggleFaq(q);
  });
  doc.addEventListener('keydown', function (e) {
    var q = e.target.closest && e.target.closest('.rl-faq__item .wf2-faq__q');
    if (q && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); toggleFaq(q); }
  });



  /* ---------- Mobile sticky bar ----------
     The same code also lives inline in mwc-sticky-cta.liquid, so the bar works if either
     file is out of date. Whichever runs first sets it up; later runs only re-attach a
     freshly rendered bar (theme editor reloads). */
  (function () {
    function setupSticky() {
      var bars = document.querySelectorAll('[id="mwc-sticky-cta"]');
      if (!bars.length) return;
      var portal = document.querySelector('.mwc-sticky-portal');
      var fresh = null;
      Array.prototype.forEach.call(bars, function (b) { if (!portal || !portal.contains(b)) fresh = b; });
      if (window.__mwcStickyInit && !fresh) return;       // already set up, nothing new
      var bar = fresh || bars[bars.length - 1];
      Array.prototype.forEach.call(bars, function (b) { if (b !== bar) b.remove(); });
      if (!portal) {
        portal = document.createElement('div');
        portal.className = 'wf2-root mwc-sticky-portal';
        document.body.appendChild(portal);
      }
      if (bar.parentNode !== portal) portal.appendChild(bar);   // escape theme transforms
      bar.classList.remove('is-hidden');
      window.__mwcStickyInit = true;

      var ticking = false;
      function update() {
        ticking = false;
        var b = document.getElementById('mwc-sticky-cta');
        if (!b) return;
        var vh = window.innerHeight;
        var hero = document.querySelector('[data-mwc-track="hero"]');
        var pricing = document.getElementById('mwc-pricing-card');
        var finalCta = document.querySelector('[data-mwc-track="final-cta"]');
        var heroPassed = !hero || hero.getBoundingClientRect().bottom <= 0;
        var p = pricing && pricing.getBoundingClientRect();
        var pricingOnScreen = !!(p && p.top < vh && p.bottom > 0);
        var f = finalCta && finalCta.getBoundingClientRect();
        var finalReached = !!(f && f.top < vh);
        var off = !window.__mwcStickyPreview && (!heroPassed || pricingOnScreen || finalReached);
        b.classList.toggle('mwc-sticky--off', off);
        b.classList.toggle('mwc-sticky--on', !off);
        b.classList.toggle('mwc-sticky--preview', !!window.__mwcStickyPreview);
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      if (window.__mwcStickyScroll) {
        window.removeEventListener('scroll', window.__mwcStickyScroll);
        window.removeEventListener('resize', window.__mwcStickyScroll);
      }
      window.__mwcStickyScroll = onScroll;
      window.__mwcStickyUpdate = update;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }
    if (!window.__mwcStickyBound) {
      window.__mwcStickyBound = true;
      document.addEventListener('shopify:section:load', function () { setTimeout(setupSticky, 0); });
      function preview(e, on) {
        var bar = document.getElementById('mwc-sticky-cta');
        if (!bar || !e.detail) return;
        var sid = bar.getAttribute('data-section-id');
        if (sid && sid !== e.detail.sectionId) return;
        if (!sid && !/sticky/.test(e.detail.sectionId || '')) return;
        window.__mwcStickyPreview = on;
        if (window.__mwcStickyUpdate) window.__mwcStickyUpdate();
      }
      document.addEventListener('shopify:section:select', function (e) { preview(e, true); });
      document.addEventListener('shopify:section:deselect', function (e) { preview(e, false); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupSticky);
    else setupSticky();
  })();

  /* ---------- Observers (sticky CTA + section views) ---------- */
  var io, stickyObservers = [];
  var seen = Object.create(null);

  function bindObservers() {
    if (!('IntersectionObserver' in window)) return;

    // Section views (50% visible, once per page view)
    if (io) io.disconnect();
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio < 0.5) return;
        var name = entry.target.getAttribute('data-mwc-track');
        if (!name || seen[name]) return;
        seen[name] = true;
        track('mwc_section_view', { section: name });
      });
    }, { threshold: 0.5 });
    doc.querySelectorAll('[data-mwc-track]').forEach(function (el) { io.observe(el); });

    // Sticky CTA
    stickyObservers.forEach(function (o) { o.disconnect(); });
    stickyObservers = [];
    return; // the sticky bar is handled by setupSticky() above
    var sticky = null;
    var hero = doc.querySelector('[data-mwc-track="hero"]');
    var pricing = doc.getElementById('mwc-pricing-card');
    var finalCta = doc.querySelector('[data-mwc-track="final-cta"]');
    // Shown only after the hero has scrolled fully off screen
    var heroPassed = !hero, pricingVisible = false, finalPassed = false;
    var debug = /[?&]mw_debug=1/.test(location.search);
    function update() {
      var off = !heroPassed || pricingVisible || finalPassed;
      sticky.classList.toggle('mwc-sticky--off', off);
      sticky.classList.toggle('mwc-sticky--on', !off);
      sticky.classList.remove('is-hidden');
      if (debug) console.log('[mwc] sticky', off ? 'hidden' : 'shown', { heroPassed: heroPassed, pricingVisible: pricingVisible, finalPassed: finalPassed });
    }
    if (hero) {
      var o0 = new IntersectionObserver(function (en) {
        heroPassed = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; update();
      }, { threshold: 0 });
      o0.observe(hero); stickyObservers.push(o0);
    }
    if (pricing) {
      var o1 = new IntersectionObserver(function (en) { pricingVisible = en[0].isIntersecting; update(); }, { threshold: 0.2 });
      o1.observe(pricing); stickyObservers.push(o1);
    }
    if (finalCta) {
      var o2 = new IntersectionObserver(function (en) {
        finalPassed = en[0].isIntersecting || en[0].boundingClientRect.top < 0; update();
      }, { threshold: 0 });
      o2.observe(finalCta); stickyObservers.push(o2);
    }
    update();
  }

  function initAll() { bindObservers(); initPosts(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  doc.addEventListener('shopify:section:load', initAll);
  doc.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-mwc-sticky-section]')) {
      var portal = doc.querySelector('.mwc-sticky-portal');
      if (portal) portal.remove();
    }
    setTimeout(bindObservers, 0);
  });
})();
